@if (actualPage) {
  <div class="offerView offer-view">
    @if (actualPage.viewFile) {
      <div class="mb-5 offer-view__image-wrapper">
        <img class="offer-view__image"
             [ngSrc]="actualPage.viewFile.src"
             [width]="imageService.width"
             [height]="imageService.height"
             [priority]="true"
             [alt]="actualPage.viewFile.altText">
      </div>
    }
    @if (actualPage.viewDescription) {
      <div class="mb-5 offer-view__description-wrapper">
        <div class="offerViewDescription offer-view__description" [innerHtml]="actualPage.viewDescription"></div>
      </div>
    }
  </div>
}

<div class="row offer-header" [className]="CssPropertiesEnum.offerHeaderClasses|cssProperty: vHostService"
     id="offerHeader">
  <div class="col-12 offer-header__title">
    <h3 class="offer-header__intro" *appApplyIfNotEmpty="translationService.getTranslation('offer_intro')"
        [innerHTML]="translationService.getTranslation('offer_intro')"></h3>
  </div>
  <div class="col-12 offer-header__description">
    <p class="offer-header__description-text"
        [innerHTML]="translationService.getTranslation('offer_description')"></p>
  </div>
</div>
<div [className]="'row offer-errors' + errorsArr.length ? ' mb-3' : ''">
  <div class="col-12 offer-errors__container" id="offerErrors">
    <app-general-errors class="offer-errors__general" [errors]="errorsArr"></app-general-errors>
    @if (isLoadingOffer) {
      <div class="offer-errors__spinner" style="text-align: center;" id="offerSpinner">
        <app-loading-spinner/>
      </div>
    }
  </div>
</div>

<div class="offerPage offer-page" id="offers">
  <div class="row offer-page__row">
    @for (offer of offers; track offer) {
      @if (activeGroup === offer.offerGroup) {
        <div [className]="(hasCustomResponsivClasses() ? getCustomResponsivClasses() : 'col-12 col-md-6 col-lg-4' ) + ' mb-5 offer-page__card'">
          <app-offer-card class="offer-page__offer-card" [offer]="offer"></app-offer-card>
        </div>
      }
    }

    @for (externalOffer of externalOffers; track externalOffer) {
      <div [className]="(hasCustomResponsivClasses() ? getCustomResponsivClasses() : 'col-12 col-md-6 col-lg-4' ) + ' mb-5 offer-page__card'">
        <app-external-offer-card class="offer-page__external-offer-card"
                                 [externalOffer]="externalOffer"></app-external-offer-card>
      </div>
    }
  </div>
  @if (moreThanOneGroup) {
    <div class="mt-5 float-end offer-page__back">
      <button mat-raised-button (click)="goBackToGroupView()" class="offer-page__back-button">
        {{translationService.getTranslation('button_back')}}
      </button>
    </div>
  }
</div>
